import { render, staticRenderFns } from "./latelyFile.vue?vue&type=template&id=0419b75a&scoped=true"
import script from "./latelyFile.vue?vue&type=script&lang=js"
export * from "./latelyFile.vue?vue&type=script&lang=js"
import style0 from "./latelyFile.vue?vue&type=style&index=0&id=0419b75a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0419b75a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0419b75a')) {
      api.createRecord('0419b75a', component.options)
    } else {
      api.reload('0419b75a', component.options)
    }
    module.hot.accept("./latelyFile.vue?vue&type=template&id=0419b75a&scoped=true", function () {
      api.rerender('0419b75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/layout/latelyFile.vue"
export default component.exports